import { rand } from './src/utils/numbers';

import Config from './config';

const newCartURL = 'https://cart.delikateska.ru/graphql';
const _storageKey = 'newCartValue';
const newCartPercentage = 100;

const ConfigOriginal = { ...Config };

if (lsTest()) {
  // Local storage available
  let value = localStorage.getItem(_storageKey);

  if (value == null) {
    const generateRand = rand(1, 100);
    value = generateRand <= newCartPercentage ? '1' : '0';

    localStorage.setItem(_storageKey, value);
  }

  if (
    value === '1' &&
    location.hostname !== 'localhost' &&
    location.hostname !== '192.168.100.161' &&
    location.hostname !== '192.168.100.116'
  ) {
    // Available new cart
    ConfigOriginal.server.api = newCartURL;
  }
}

/**
 * ЭТАП 2 (SSR): ветка выше целиком висит на `lsTest()`, то есть на наличии
 * localStorage. На сервере его нет — ветка не отрабатывала, и cart-эндпоинт
 * оставался СТАРЫМ (`config.ts` -> api.delikateska.ru/graphql/). Запрос
 * оттуда возвращает HTML, а не JSON, и `graphqlStageOld.callMethod` падал на
 * JSON.parse: «Unexpected token '<'». До перевода /stores/:id на SSR это не
 * всплывало — ни один серверный префетч не ходил через APIStage.
 *
 * Доля новой корзины 100% (newCartPercentage), а прод-хост никогда не
 * localhost, значит любой реальный браузер ходит в newCartURL. Сервер обязан
 * ходить туда же: иначе SSR и клиент берут данные из РАЗНЫХ API.
 *
 * Известное расхождение: если открыть дев именно по адресу `localhost`,
 * клиент по условию выше останется на старом эндпоинте, а сервер уйдёт на
 * новый. На 127.0.0.1 (наш e2e-адрес) и в проде расхождения нет.
 */
if (typeof window === 'undefined') {
  ConfigOriginal.server.api = newCartURL;
}

export default ConfigOriginal;

function lsTest(): boolean {
  const test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}
